class Row {
	key: any;

	columns: any;

	rows: any;

	renderer: any;

	customClass: any;

	constructor(key: any, type?: any, columns: any[] = [], rows: any[] = []) {
		this.key = key;
		this.columns = columns;
		this.rows = rows;
		this.renderer = null;
		this.customClass = null;
	}

	setKey = (key: any) => {
		this.key = key;
		return this;
	};

	getKey = () => this.key;

	addColumn = (column: any) => {
		this.columns.push(column);
		return this;
	};

	getColumns = () => this.columns;

	addRows = (row: any) => {
		this.rows.push(row);
		return this;
	};

	getRows = () => this.rows;

	setCustomClass = (customClass: any) => {
		this.customClass = customClass;
		return this;
	};

	getCustomClass = () => this.customClass;
}

export default Row;
